export class FindFinished {
  
  constructor(private findActive: boolean = true, private all: boolean = false) {
  }
}
